/* =========================================================
   VELMORA — Recently viewed products
   Handles are stored in the visitor's own browser (localStorage) and
   never leave it. Product data is fetched live from Shopify's public
   /products/{handle}.js endpoint, so prices, images and availability
   are always current — nothing about the catalog is hardcoded.
   ========================================================= */
(function () {
  "use strict";

  var KEY = "velmora_recently_viewed";
  var MAX_STORED = 12;

  function safeGet() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function safeSet(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable (private mode, blocked cookies) — skip silently */
    }
  }

  function track(handle) {
    if (!handle) return;
    var list = safeGet().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    safeSet(list.slice(0, MAX_STORED));
  }

  function money(cents) {
    if (window.Velmora && window.Velmora.formatMoney) {
      return window.Velmora.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : str;
    return div.innerHTML;
  }

  function fromLabel(priceStr) {
    var tpl = window.Velmora && window.Velmora.fromPriceLabel;
    return tpl ? tpl.replace("[price]", priceStr) : priceStr;
  }

  function cardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || "";
    var img2 = p.images && p.images[1] ? p.images[1] : "";
    var url = escapeHtml(p.url);
    var title = escapeHtml(p.title);

    var guardZero = !(window.Velmora && window.Velmora.hideZeroPrices === false);
    // Lowest non-zero variant price, mirroring snippets/price.liquid.
    var lowestReal = 0;
    (p.variants || []).forEach(function (v) {
      if (v.price > 0 && (lowestReal === 0 || v.price < lowestReal)) lowestReal = v.price;
    });

    var priceText;
    if (guardZero && p.price === 0) {
      priceText = lowestReal > 0
        ? fromLabel(money(lowestReal))
        : '<span class="price--on-request">' +
            escapeHtml((window.Velmora && window.Velmora.zeroPriceLabel) || "") +
          "</span>";
    } else {
      priceText = p.price_varies ? fromLabel(money(p.price)) : money(p.price);
    }

    return (
      '<div class="product-card">' +
        '<div class="product-card__media-wrap">' +
          '<a href="' + url + '" class="product-card__media media-zoom media-fade-swap ratio-box ratio-box--portrait" tabindex="-1" aria-hidden="true">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy" width="700" height="875">' : "") +
            (img2 ? '<img class="is-secondary" src="' + escapeHtml(img2) + '" alt="" loading="lazy" width="700" height="875">' : "") +
          "</a>" +
        "</div>" +
        '<div class="product-card__info">' +
          '<a href="' + url + '" class="product-card__title">' + title + "</a>" +
          '<span class="product-card__price">' + priceText + "</span>" +
        "</div>" +
      "</div>"
    );
  }

  function render() {
    var container = document.querySelector("[data-recently-viewed]");
    if (!container) return;

    var currentHandle = container.getAttribute("data-current-handle");
    var limit = parseInt(container.getAttribute("data-limit"), 10) || 4;
    var handles = safeGet()
      .filter(function (h) {
        return h && h !== currentHandle;
      })
      .slice(0, limit);

    if (!handles.length) {
      container.hidden = true;
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch("/products/" + encodeURIComponent(handle) + ".js")
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        container.hidden = true;
        return;
      }
      var grid = container.querySelector("[data-recently-viewed-grid]");
      if (grid) grid.innerHTML = valid.map(cardHTML).join("");
      container.hidden = false;
      document.dispatchEvent(new CustomEvent("velmora:content-updated"));
    });
  }

  var productRoot = document.querySelector("[data-product-handle]");
  if (productRoot) {
    track(productRoot.getAttribute("data-product-handle"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", render);
  } else {
    render();
  }
})();
